import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TState } from 'app-entities/projects/types/slice-state.type';
import { TResponseError } from 'common/types/response-error.type';
import { TRequestProjectPayload } from 'app-entities/projects/types/request-project-payload.type';
import { TExtendedProject } from 'app-entities/projects/types/project.type';
import { TSuccessResponse } from 'app-entities/projects/types/success-projects-response';
import { DEFAULT_PROJECTS_COUNT_PER_REQUEST, ZERO_PAGE } from 'app-entities/projects/projects.const';

export const initialState: TState = {
  list: [],
  isLoading: false,
  error: null,
  totalElements: 0,
  totalPages: 0,
  lastSearchParams: {
    page: ZERO_PAGE,
    size: DEFAULT_PROJECTS_COUNT_PER_REQUEST,
    regionId: '',
    showProjectMinPrice: false,
    showProjectName: false,
    inspirationRooms: null,
  },
};

export const projectsSlice = createSlice({
  name: 'projects',
  initialState,
  reducers: {
    requestProjects: (state, action: PayloadAction<TRequestProjectPayload>) => {
      state.isLoading = true;
      state.error = null;
      state.lastSearchParams = action.payload;
    },
    setSuccessProjectsResponse(
      state,
      action: PayloadAction<
        Omit<TSuccessResponse, 'items'> & {
          items: TExtendedProject[];
        }
      >
    ) {
      const { items, totalPages, totalElements } = action.payload;
      state.list = state.list.concat(items);
      state.totalPages = totalPages;
      state.totalElements = totalElements;
      state.isLoading = false;
    },
    setError(state, action: PayloadAction<TResponseError>) {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
  selectors: {
    selectProjects: state => state.list,
    selectFirstLoadIsError: state => state.list.length === 0 && !!state.error,
    selectIsLoading: state => state.isLoading,
    selectLastSearchParams: state => state.lastSearchParams,
    selectNextSearchPage: state => {
      if (state.error) {
        return state.lastSearchParams.page;
      }
      return state.lastSearchParams.page + 1;
    },
    selectIsNextPageAvailable: state => {
      const {
        totalPages,
        lastSearchParams: { page },
        error,
      } = state;

      return error !== null ? true : totalPages > page + 1;
    },
  },
});
